import { BusinessUnitModel } from '..';
import { DocMetrics } from '../../pages/erp/document/line-item-container/line-item-metrics/line-item-metrics.component';
import { CompilationModel } from './compilation';
import { FinishedProductModel } from './finishedProduct';
import { PriceItem, PriceMatrixModel } from './priceMatrix';
import { SpoBoxModel } from './spoBox';

export interface IRelatedOC {
  parentPos: number;
  pos: number;
  quantity: number;
  doc: CompilationModel;
}

// eslint-disable-next-line no-shadow
export enum EPdfExportType {
  none = 0,
  single,
  merged,
  attachments,
  zipAll,
}
export enum ETdsExportType {
  none = 0,
  single
}


export class AssociatedPfspo {
  code: string;
  version: number;
  lineItem: string;
  pos: number;
  internalPos: number;
  parentPos: number;
  quantity: number;
  // boxes: SpoBoxModel[];
  text: string;
  doc: CompilationModel; // not in DB
  docLineItem: LineItemModel; // not in DB
}

export class LegacyData {
  businessUnit: BusinessUnitModel;
  trialNumber: string;
  productCode: string;
  productName: string;
  dimensions: string;
  lineItemPosition: string;
}

export class BoxDetails {
  selected: boolean;
  boxId: number;
  case: string;
  obic: string;
  article: string;
  dimension: string;
  lot: string;
  quantity: number;
  tc: string;
  tcDate: Date;
  boxName: string;
  lwh: string;
  grossWeight: number;
  netWeight: number;
  prodDate: Date;
  expiryDate: Date;
  joints: string;
  boxType: string; // CB1, CB2, ....
}

export class LineItemPosition {
  id: string;
  internalPos: number;
  orderPos: number;
  posOverride: string;
}

export class LineItemModel {
  public _id?: string;

  public code: string; // TODO: remove legacy field ( -> now in position.id )
  public position: LineItemPosition;
  public productCompilation: CompilationModel;
  public parent: LineItemModel;
  public finishedProduct: FinishedProductModel;
  public quantity: number = 0;
  public piecePrice: number = 0;  // currency; rounded, applied piece price;
  public calculatedPiecePrice: number = 0; // calculated piece price for reference;
  public displayUnit: number = 1;   // id of DisplayUnitData in CompilationData.ts (Dashboard->models)
  public displayUnitQuantity: number = 0;
  public displayUnitPrice: number = 0 // currency;
  public metricsUnit: number;
  public metricsPrice: number;
  public weight: number;
  public packingType: string;
  public palletRef: string;
  public boxDetails: BoxDetails[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public VATPercent: number = 0;
  public invoicePercent: number = 100;
  public discount: number = 0;
  public productName: string;
  public hsCode: string;
  public countryOfOrigin: string;
  public attributeRemark: string; // customer product name
  public attributeCode: string; // customer product code
  public publicRemark: string;
  public adminText: string;
  public expiryDate: string;
  public factoryOrderNumber: string;
  public numberOfTC: string;
  public dateOfProduction: Date;
  public dateOfTC: Date;
  public dateCreated: Date;
  public dateUpdated: Date;
  public tbCode: string;  // == OBIC
  public tcChecked: boolean = true;
  public poVisibility: { poNum: boolean, poPos: boolean, poDelivery: boolean }; // replaces posPDinPdf
  public finishedProductPdf: EPdfExportType = EPdfExportType.none;
  public technicalDatasheets: ETdsExportType[] = [];
  public pfspo: AssociatedPfspo[];
  public dateOfDelivery: Date;
  public posPDinPdf: boolean = true; // legacy, replaced by poVisibility
  public partialDelivery: { num: number, sum: number } = { num: 0, sum: 0 }
  public palletQty: string;
  public showCustomerProductSpecification: boolean;
  public storedPartialDelivery: { num: number, sum: number } = { num: 0, sum: 0 } // dummy, not in db
  public matrixPriceItem: PriceMatrixModel; // dummy, not in db
  public matrixPiecePrice: number; // dummy, not in db
  public docMetrics: Partial<DocMetrics>; // dummy, not in db

  public legacyData: LegacyData;

  public relatedOCs: IRelatedOC[]; // not in DB
}
